module.exports = __webpack_public_path__ + "static/media/image_26.6170e639.png";